import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";

const HomeDashboard = () => {
  return (
    <CommonLayout dashboard={true}>
      <Outlet />
    </CommonLayout>
  );
};

export default HomeDashboard;
